export const meta = { id: 'O32', slug: 'acompanhar-progresso', title: 'Como acompanhar o Progresso da Formação', description: 'Acompanhe o progresso individual dos participantes por Etapas, Componentes e regras de liberação.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 620, keywords: ['progresso','participantes','formação','etapas','componentes'], previous: 'O31', next: 'O33', related: ['O31','O33','A13'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como acompanhar o Progresso da Formação

Cada participante possui um progresso individual dentro da Formação.

<HelpImage pendingId="O31.1" alt="Visão de progresso dos participantes de uma Formação" />

## O que observar

- Etapa atual;
- Componentes concluídos e pendentes;
- Componentes bloqueados por pré-requisito;
- itens obrigatórios e opcionais;
- progresso do Treinamento quando ele compõe a Formação;
- próxima ação disponível;
- situação de conclusão.

<Callout type="tip">Use o progresso para entender onde a pessoa está no percurso. Percentuais sem contexto não explicam, sozinhos, a qualidade do desenvolvimento.</Callout>
